<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/clb-alipay-flow/table">查理宝支付宝流水列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <el-table :data="table"
                stripe
                highlight-current-row
                :show-header="false"
                class="margin b15"
                style="width: 100%">
        <el-table-column width="150">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
          <template slot-scope="scope">
            <div>{{scope.row.value}}</div>
          </template>
        </el-table-column>
      </el-table>
      <router-link to="/clb-alipay-flow/table">
        <el-button type="primary">返回</el-button>
      </router-link>
    </layout-panel>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data () {
    return {
      table: [
        {
          key: 'id',
          label: '查理宝支付宝流水ID',
          value: '',
        },
        {
          key: 'name',
          label: '查理宝支付宝流水名称',
          value: '',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
        {
          key: 'updated_at',
          text: '更新日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('getClbAlipayFlowDetail', {id}).then(({data}) => {
        this.table.forEach(obj => {
          if (data[obj.key]) {
            obj.value = data[obj.key]
          }
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/clb-alipay-flow/pages/ClbAlipayFlowDetail.vue